import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Clearfix from 'components/elements/clearfix';
import Confirm from 'components/elements/confirm-element';
import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import Message from 'rc-message';
import AttachmentContainer from 'containers/AttachmentContainer';
import {
  getList as getAttachs,
  deleteOne as deleteAttach,
  create as createcAttach,
} from 'api/biodiversityAttachmentApi';
import { deleteOne } from 'api/biodiversityApi';
import Permissions from 'react-redux-permissions';
import { Link } from 'react-router-dom';
import slug from 'constants/slug';
import { Col, Row } from 'reactstrap';
import { get } from 'lodash';
import moment from 'moment';
import { getLookupBiodiversityAttachment } from 'api/lookuplistitemApi';
import { COLOR } from 'config';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const ItemValue = styled.div`
  font-size: 14px;
  .required {
    color: #660000;
    font-weight: 700;
  }
`;

const RowValue = (props) => {
  return (
    <ItemValue>
      <Row>
        <Col xs={5} className={props.required ? 'required' : ''}>
          {props.label}
        </Col>
        <Col xs={7}>{props.value}</Col>
      </Row>
      <Clearfix height={8} />
    </ItemValue>
  );
};

export default class BiodiversityDetail extends React.Component {
  static propTypes = {
    initialValue: PropTypes.object,
    BiodiversityID: PropTypes.string,
  };

  handleDelete = () => {
    const { initialValue, history } = this.props;
    this.ConfirmElm.showConfirm({
      content: (
        <div>
          {`Bạn có muốn xóa tên dự án: `}{' '}
          <b>{get(initialValue, 'ProjectName')}</b>
        </div>
      ),
      cb: async (value) => {
        if (value) {
          const res = await deleteOne(initialValue._id);
          if (res.success) {
            Message.success({ content: 'Thành Công' });
            history.push(slug.BIODIVERSITY.LIST);
          }
          if (res.error) Message.error({ content: res.message });
        }
      },
    });
  };

  render() {
    const { initialValue } = this.props;
    return (
      <div style={{ width: '100%' }}>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
        <Clearfix height={8} />
        <HeaderContainer>
          <div style={{ display: 'inline-flex' }}>
            <Link to={slug.BIODIVERSITY.LIST}>
              <Icon
                style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                icon={IconNames.CIRCLE_ARROW_LEFT}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.SUCCESS}
              />
            </Link>

            <Permissions allowed={[`biodiversity.write`]}>
              <Fragment>
                <Clearfix width={8} />
                <Link
                  to={slug.BIODIVERSITY.EDIT_WITH_ID + get(initialValue, '_id')}
                >
                  <Icon
                    style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                    icon={IconNames.MANUALLY_ENTERED_DATA}
                    iconSize={Icon.SIZE_LARGE}
                    intent={Intent.PRIMARY}
                  />
                </Link>
              </Fragment>
            </Permissions>

            <Permissions allowed={[`biodiversity.delete`]}>
              <Fragment>
                <Clearfix width={8} />
                <Icon
                  style={{ cursor: 'pointer' }}
                  icon={IconNames.BAN_CIRCLE}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.DANGER}
                  onClick={this.handleDelete}
                />
              </Fragment>
            </Permissions>
          </div>
        </HeaderContainer>
        <Clearfix height={8} />
        <Row>
          <Col xs={6}>
            <RowValue
              required
              label='Số văn bản (quyết định/báo cáo)'
              value={get(initialValue, 'NumberDoc')}
            />
            <RowValue
              required
              label='Năm báo cáo'
              value={get(initialValue, 'ReportYear')}
            />
            <RowValue
              label='Cơ quan chủ quản'
              value={get(initialValue, 'Agency')}
            />
            <RowValue
              label='Cơ quan phê duyệt'
              value={get(initialValue, 'ResultsManagementAgency')}
            />
            <RowValue
              label='Cơ quan chủ trì'
              value={get(initialValue, 'Admisnistor')}
            />
            <RowValue
              label='Cơ quan tư vấn'
              value={get(initialValue, 'ConsultingAgency')}
            />
            <RowValue
              label='Mục tiêu dự án'
              value={get(initialValue, 'ProjectObjectives')}
            />
            <RowValue label='Ghi chú' value={get(initialValue, 'Notes')} />
            <RowValue
              label='Thêm vào'
              value={
                get(initialValue, 'AddedOn')
                  ? moment(get(initialValue, 'AddedOn')).format(
                    'DD/MM/YYYY HH:mm'
                  ) +
                  ' bởi ' +
                  get(initialValue, 'AddedBy')
                  : ''
              }
            />
            <RowValue
              label='Cập nhật lần cuối'
              value={
                get(initialValue, 'UpdatedOn')
                  ? moment(get(initialValue, 'UpdatedOn')).format(
                    'DD/MM/YYYY HH:mm'
                  ) +
                  ' bởi ' +
                  get(initialValue, 'UpdatedBy')
                  : ''
              }
            />
          </Col>
        </Row>
        <AttachmentContainer
          getListFunc={(query) => {
            return getAttachs({
              ...query,
              BiodiversityID: this.props.BiodiversityID,
            });
          }}
          createOne={(obj) =>
            createcAttach({ BiodiversityID: initialValue._id, ...obj })
          }
          deleteOne={deleteAttach}
          moduleName='biodiversity'
          getAttachmentTypeList={getLookupBiodiversityAttachment}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityView/BiodiversityDetail/index.js